import supabase from '../supabaseClient';

// Usage: authFetch(url, { method, headers, body })
export default async function authFetch(url, options = {}) {
  const { data } = await supabase.auth.getSession();
  const accessToken = data?.session?.access_token;
  const headers = new Headers(options.headers || {});
  if (accessToken) headers.set('Authorization', `Bearer ${accessToken}`);
  // Default to JSON if body is object and no content-type set
  const isJsonBody = options.body && typeof options.body === 'object' && !(options.body instanceof FormData);
  if (isJsonBody && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const finalOpts = { ...options, headers };
  if (isJsonBody) finalOpts.body = JSON.stringify(options.body);
  return fetch(url, finalOpts);
}
